// Warning: this will be re-generated on CI server
export const APP_VERSION: string = "1.1.7";
export const APP_BUILD_NUMBER: string = "4901";
export const APP_BUILD_TIME: number = 1793856842765;
export const APP_GIT_COMMIT: string = "b7601a72";
export const APP_GIT_BRANCH: string = "develop";
